module.exports = __webpack_public_path__ + "2e5b8c9967fdd0a45ae54ed46d684a5e.svg";